import './RevItUpPopup.css';
import decorationTop from '../img/container-decotration-red.webp';
import decorationBottom from '../img/container-decotration-red-bottom.webp';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link
} from "react-router-dom";

export default function RevItUpPopup() {
    return (
        <div className="RevItUpPopup">
            <img className="decorationTop" src={decorationTop} alt="decoration" />
            <h2 className="RevItUpPopup__h2">Ready to Rev it up?</h2>
            <p className="RevItUpPopup__text">Rev your soul. Rev your engine. Rev your BŌSŌ NFTs.
                Staking your BŌSŌ NFTs will passively earn you rewards.</p>
            <Link to="/revving" target="_blank" className="RevItUpPopup__link">REV</Link>
            <img className="decorationBottom" src={decorationBottom} alt="decoration" />
        </div>
    );
}